import React, { useRef, useState } from 'react';
import NoteCard from './NoteCard';
import CanvasConnections from './CanvasConnections';
import { motion } from 'framer-motion';

const CanvasView = ({ notes, updateNotePosition, connections, isPresentationMode }) => {
  const containerRef = useRef(null);
  const [pan, setPan] = useState({ x: 0, y: 0 });

  const handleDragEnd = (id, info) => {
    // Update position in state relative to pan
    const note = notes.find(n => n.id === id);
    if (note) {
      updateNotePosition(id, note.x + info.offset.x, note.y + info.offset.y);
    }
  };

  return (
    <div className={`relative w-full h-full overflow-hidden bg-paper bg-[length:24px_24px] ${isPresentationMode ? 'bg-white' : 'bg-dot-pattern'}`}>
      <motion.div 
        drag
        dragConstraints={{ left: -2000, right: 2000, top: -2000, bottom: 2000 }}
        className="absolute inset-0 w-[4000px] h-[4000px]"
        initial={{ x: -500, y: -500 }}
      >
        <CanvasConnections notes={notes} connections={connections} />
        {notes.map(note => (
          <NoteCard 
            key={note.id} 
            note={note} 
            onDragEnd={handleDragEnd} 
          />
        ))}
      </motion.div>
      
      {/* Mini-map or status indicators could go here */}
      <div className="absolute bottom-6 right-6 flex gap-2">
        <div className="bg-paper-light border border-paper-dark px-3 py-1.5 rounded-full text-xs font-semibold text-ink-muted shadow-sm flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-maple"></span>
          Live Sync
        </div>
      </div>
    </div>
  );
};

export default CanvasView;